'use client';

import React from 'react';
import { TitleDescription } from '@sapientpro/sapientpro-data-models';
import styles from './Facts.module.scss';

interface IProps {
  facts: Array<TitleDescription>;
}

const Facts = ({ facts }: IProps) => (
  <div className={styles.wrapper}>
    <div className={styles.facts}>
      {facts.map(fact => (
        <div
          key={fact.id}
          className={styles.fact}
        >
          <p className={styles.fact__value}>{fact.title}</p>
          <p className={styles.fact__title}>{fact.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Facts;
